<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { ErrorIcon, WarningIcon } from "@infinitro/icons";
import { stateUi } from "@infinitro/config";
import { onMount } from "svelte";
let { value = $bindable(""), placeholder: placeholderProp, disabled = false, icon = null, endIcon = null, endIconProps = {}, inputmode = undefined, customClasses = "", cols = 1, inputClasses = "", iconClasses = "", endIconClasses = "", error = false, warning = false, message = "", size = "large", id = "", type = "text", name = "", autocomplete = "off", required = false, readonly = false, maxlength = undefined, minlength = undefined, pattern = undefined, step = undefined, title = undefined, rows = 8, element = $bindable(null), customStyles = "", loading = false, autoResizeTextarea = false, customBorderRadius = undefined, transparentBackground = false, onInput, onBlur, onFocus, onKeydown, onClick, components, componentsEnd } = $props();
onMount(() => {
	if (autoResizeTextarea && type === "textarea") {
		autoResizeInput();
	}
});
const placeholder = $derived(placeholderProp ?? $t(Verbiage.write_here));
let textareaContainerHeight = $state("96px");
const useAlternative2 = $derived($stateUi.input.inputStyle === "alternative2");
const useAlternative4 = $derived($stateUi.input.inputStyle === "alternative4" || $stateUi.sidebar?.sidebarStyle === "alternative4");
const useTransparentBackground = $derived(transparentBackground || ($stateUi.input?.transparentBackground ?? false));
function autoResizeInput() {
	if (element) {
		element.style.height = "37px";
		element.style.height = `${element.scrollHeight}px`;
		textareaContainerHeight = `${element.scrollHeight}px`;
	}
}
function handleInput(event) {
	const inputValue = event.target.value;
	if (autoResizeTextarea) {
		autoResizeInput();
	}
	onInput?.(inputValue, event);
}
function handleBlur(event) {
	onBlur?.(event);
}
function handleFocus(event) {
	onFocus?.(event);
}
function handleKeydown(event) {
	onKeydown?.(event);
}
function handleClick(event) {
	onClick?.(event);
}
</script>

<div class="component-container">
	<div
		class={`input-container ${type === 'textarea' ? 'textarea-container' : ''} ${size} ${customClasses} ${disabled ? 'input-disabled' : ''} ${error ? 'input-error' : ''} ${warning ? 'input-warning' : ''} ${useAlternative2 ? 'input-alternative2' : ''} ${useTransparentBackground ? 'input-transparent' : ''} ${useAlternative4 ? 'input-alternative4' : ''}`}
		style={`
		${textareaContainerHeight !== '96px' ? `height:${textareaContainerHeight};` : ''}
		${customBorderRadius ? `--border-radius-input:${customBorderRadius};` : ''}
	`}
	>
		{#if error || warning}
			<div
				class={`background-layer ${error ? 'input-error' : ''} ${warning ? 'input-warning' : ''}`}
			></div>
		{/if}
		{#if icon && type !== 'textarea'}
			<div class={`input-icon ${size} ${iconClasses}`}>
				{#if typeof icon === 'string'}
					<img src={icon} alt={$t(Verbiage.input_icon_alt, 'alts')} />
				{:else if icon}
					{@const Icon = icon}
					<Icon />
				{/if}
			</div>
		{/if}
		{@render components?.()}
		{#if type === 'text'}
			<input
				{id}
				type="text"
				{placeholder}
				bind:value
				class={`input ${inputClasses}`}
				{disabled}
				{name}
				{autocomplete}
				{required}
				{readonly}
				{maxlength}
				{minlength}
				{pattern}
				{step}
				{title}
				style={customStyles}
				oninput={handleInput}
				onblur={handleBlur}
				onfocus={handleFocus}
				onkeydown={handleKeydown}
				onclick={handleClick}
				bind:this={element}
			/>
		{:else if type === 'email'}
			<input
				{id}
				type="email"
				{placeholder}
				bind:value
				class={`input ${inputClasses}`}
				{disabled}
				{name}
				{autocomplete}
				{required}
				{readonly}
				{maxlength}
				{minlength}
				{pattern}
				{step}
				{title}
				style={customStyles}
				oninput={handleInput}
				onblur={handleBlur}
				onfocus={handleFocus}
				onkeydown={handleKeydown}
				onclick={handleClick}
				bind:this={element}
			/>
		{:else if type === 'password'}
			<input
				{id}
				type="password"
				{placeholder}
				bind:value
				class={`input ${inputClasses}`}
				{disabled}
				{name}
				{autocomplete}
				{required}
				{readonly}
				{maxlength}
				{minlength}
				{pattern}
				{step}
				{title}
				style={customStyles}
				oninput={handleInput}
				onblur={handleBlur}
				onfocus={handleFocus}
				onkeydown={handleKeydown}
				onclick={handleClick}
				bind:this={element}
			/>
		{:else if type === 'number'}
			<input
				{id}
				type="number"
				{placeholder}
				bind:value
				class={`input ${inputClasses}`}
				{disabled}
				{name}
				{autocomplete}
				{required}
				{readonly}
				{maxlength}
				{minlength}
				{pattern}
				{step}
				{title}
				{inputmode}
				style={customStyles}
				oninput={handleInput}
				onblur={handleBlur}
				onfocus={handleFocus}
				onkeydown={handleKeydown}
				onclick={handleClick}
				bind:this={element}
			/>
		{:else if type === 'textarea'}
			<textarea
				{id}
				{placeholder}
				bind:value
				class={`textarea ${inputClasses}`}
				{disabled}
				{name}
				{autocomplete}
				{required}
				{readonly}
				{maxlength}
				{minlength}
				{title}
				{rows}
				{cols}
				style={customStyles}
				oninput={handleInput}
				onblur={handleBlur}
				onfocus={handleFocus}
				onkeydown={handleKeydown}
				onclick={handleClick}
				bind:this={element}
			></textarea>
		{/if}
		{@render componentsEnd?.()}
		{#if endIcon && type !== 'textarea'}
			<div class={`end-icon ${size} ${endIconClasses}`}>
				{#if typeof endIcon === 'string'}
					<img src={endIcon} alt={$t(Verbiage.input_icon_alt, 'alts')} class:loading />
				{:else if endIcon}
					{@const EndIcon = endIcon}
					<EndIcon {...endIconProps} />
				{/if}
			</div>
		{/if}
	</div>
	{#if message && (error || warning)}
		<div
			class={`input-message ${error ? 'message-error' : ''} ${warning ? 'message-warning' : ''}`}
		>
			<span class="message-icon">
				{#if error}
					<ErrorIcon />
				{:else}
					<WarningIcon height={16} width={16} />
				{/if}
			</span>
			{message}
		</div>
	{/if}
</div>

<style>
	.component-container {
		display: flex;
		width: 100%;
		flex-direction: column;
}

	.input-container {
		position: relative;
		display: flex;
		align-items: center;
		border-radius: var(--border-radius-input);
		border-width: 1px;
		border-color: var(--component-input-border);
		background-color: var(--component-input-background);
		font-size: 0.875rem;
		line-height: 1.25rem;
		color: var(--color-text-100);
}

	.input-container:hover {
		border-color: var(--component-input-border-hover);
}

	.input-container:active {
		border-color: var(--component-input-border-active);
}

	.input-container:focus-within {
		border-color: var(--component-input-border-active);
		outline-color: var(--component-input-border-active);
	}

	.background-layer {
		position: absolute;
		inset: 0px;
		border-radius: var(--border-radius-input);
		background-color: var(--color-background-500);
}

	.input-container.input-disabled {
		opacity: 0.25;
		background: var(--gradient-alternative-4);
}

	.input-alternative2 {
		position: relative;
		border-radius: 8px;
		border-style: none;
		background: linear-gradient(
			180deg,
			rgba(var(--color-background-900-rgb) / 0.6) 0%,
			rgba(var(--color-background-900-rgb) / 0.5) 100%
		);
}

	.input-alternative2::before {
		position: absolute;
		inset: 0px;
		border-radius: 8px;
		padding: 1px;
		content: '';
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 100%);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
}

	.input-container.input-alternative2.input-error::before,
	.input-container.input-alternative2.input-warning::before {
		background: none;
	}

	.input-container.input-alternative2.input-error::after,
	.input-container.input-alternative2.input-warning::after {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: 8px;
		border: 1px solid transparent;
		pointer-events: none;
		z-index: 3;
	}

	.input-container.input-alternative2.input-error::after {
		border-color: var(--color-error-500);
	}

	.input-container.input-alternative2.input-warning::after {
		border-color: var(--color-warning-500);
	}

	.input-container.input-alternative4 {
		border-radius: 12px;
		border-width: 0px;
		border-color: var(--color-accent-700);
		background-color: var(--color-background-500);
		background-image: unset;
}

	.input-container.input-alternative4:hover,
	.input-container.input-alternative4:focus-within {
		border-width: 0px;
		border-color: var(--color-accent-700);
}

	.input-error {
		border-color: var(--color-error-500);
		background-image: none;
}

	.input-warning {
		border-color: var(--color-warning-500);
		background-image: none;
}

	.input-container .input-error {
		background-color: color-mix(in srgb,var(--color-error-500) 10%,transparent);
}

	.input-container .input-warning {
		background-color: color-mix(in srgb,var(--color-warning-500) 10%,transparent);
}

	@supports not (background: color-mix(in srgb, #000 10%, transparent)) {
		.input-container .input-error,
		.input-container .input-warning {
				position: relative;
		}

		.input-container .input-error::before,
		.input-container .input-warning::before {
			content: '';
			position: absolute;
			inset: 0px;
			border-radius: inherit;
			pointer-events: none;
		}

		.input-container .input-error::before {
			background: var(--color-error-500);
			opacity: 0.1; /* ~10% */
		}

		.input-container .input-warning::before {
			background: var(--color-warning-500);
			opacity: 0.1; /* ~10% */
		}
	}

	.input-icon,
	.end-icon {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
}

	.input-icon img,
	.end-icon img {
		height: 20px;
}

	.input-icon.small img,
	.end-icon.small img {
		height: 16px;
}

	.input-icon {
		margin-right: -8px;
		padding-left: 0.75rem;
}

	.end-icon {
		margin-left: -8px;
		padding-right: 0.75rem;
}

	.input,
	.textarea {
		position: relative;
		height: 100%;
		max-height: 90px;
		min-height: 37px;
		width: 100%;
		background-color: transparent;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 19px;
		padding-bottom: 19px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		border-radius: inherit;
}

	.input:focus,
	.textarea:focus {
		outline: 2px solid transparent;
		outline-offset: 2px;
}

	/* Keep browser autofill aligned with container shape and theme. */
	.input:-webkit-autofill {
		-webkit-text-fill-color: var(--color-text-100) !important;
		box-shadow: 0 0 0 1000px var(--color-background-900) inset;
		caret-color: var(--color-text-100);
		border-radius: inherit;
	}
	.input:-webkit-autofill,
	.input:-webkit-autofill:hover,
	.input:-webkit-autofill:focus,
	.input:autofill {
		-webkit-text-fill-color: var(--color-text-100) !important;
		box-shadow: 0 0 0 1000px var(--color-background-900) inset;
		caret-color: var(--color-text-100);
		border-radius: inherit;
	}

	.textarea {
		resize: none;
}

	.input-message {
		position: relative;
		z-index: 40;
		margin: 0.75rem;
		margin-top: 0.5rem;
		display: flex;
		align-items: center;
		border-radius: var(--border-radius-input-message);
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		font-size: 0.6rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.message-error {
		background-color: var(--color-error-900);
}

	.message-warning {
		background-color: var(--color-warning-900);
}

	.message-icon {
		margin-right: 0.25rem;
		height: 1rem;
		width: 1rem;
}

	/* Size classes */
	.input-container.large {
		height: 48px;
		font-size: 16px;
}

	.input-container.medium {
		height: 40px;
		font-size: 16px;
}

	.input-container.small {
		height: 36px;
		font-size: 16px;
}

	.textarea-container {
		max-height: 96px;
		min-height: 37px;
}

	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type='number'] {
		-moz-appearance: textfield;
	}

	.loading {
		transform-origin: center;
}

	@keyframes spin {

		to {
				transform: rotate(360deg);
		}
}

	.loading {
		animation: spin 1s linear infinite;
}

	.textarea::-webkit-scrollbar {
		width: 0.25rem;
}

	.textarea::-webkit-scrollbar-track {
		background-color: transparent;
}

	.textarea::-webkit-scrollbar-thumb {
		border-radius: 9999px;
		background-color: var(--color-secondary-500);
}

	.textarea::-webkit-scrollbar-thumb:hover {
		background-color: var(--color-neutral-100);
}

	.input-no-bg {
		background: transparent !important;
	}

	.input-no-bg .background-layer {
		display: none;
	}
	.input-transparent:is(:hover, :active) {
		background: var(--gradient-main);
	}

	.input-transparent :is(.input, .textarea) {
		background: transparent;
	}

	.input-transparent
		.input:is(:-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus, :-webkit-autofill) {
		background: transparent !important;
		box-shadow: 0 0 0 1000px transparent inset !important;
		-webkit-text-fill-color: var(--color-text-100) !important;
		caret-color: var(--color-text-100);
		-webkit-transition: background-color 9999s ease-out 0s;
		transition: background-color 9999s ease-out 0s;
	}

	.input-transparent:is(:hover, :active) :is(.input, .textarea),
	.input-transparent
		.input:is(:-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:focus, :autofill) {
		background: transparent !important;
		box-shadow: 0 0 0 1000px transparent inset !important;
		-webkit-text-fill-color: var(--color-text-100) !important;
		caret-color: var(--color-text-100);
		-webkit-transition: background-color 9999s ease-out 0s;
		transition: background-color 9999s ease-out 0s;
	}
</style>
